import { withProps } from 'recompose';
import withTutorial from '../../withTutorial';
import ListTable from '../../invoices/ListTable';
import { NoInvoiceMessage } from '../../invoices/Invoices';

export default withTutorial(NoInvoiceMessage)(withProps({ wrapped: true })(ListTable));
